import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
const BASE = BaseModel.getApiBasePath() + '/api/v1/intelliport/commands';

export default new class IntelliportCommandsModel {

  constructor() { }

  get(id) {
    return new Promise((resolve, reject) => {
      this.getAll()
        .then((data) => {
          resolve(_.find(data, { id: id }));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getAll(dateFrom = null, dateTo = null) {
    var filter = {
      order: 'created_timestamp DESC'
    };
    if (dateFrom && dateTo) {
      filter = _.merge(filter, { where: { and: [{ created_timestamp: { gte: dateFrom } }, { created_timestamp: { lte: dateTo } }] } });
    }
    return new Promise((resolve, reject) => {
      // if (!localStorage.getItem('dataset_parkinglocations') || force) {
      axios.get(BASE, {
        params: {
          access_token: UserModel.getAccessToken(),
          filter: filter
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
      // } else {
      //   resolve(JSON.parse(localStorage.getItem('dataset_parkinglocations'))); 
      // }
    });
  }

  create(data) {
    return new Promise((resolve, reject) => {
      axios.post(BASE, data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  remove(id) {
    return new Promise((resolve, reject) => {
      axios.delete(BASE + '/' + id, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

}


// WEBPACK FOOTER //
// ./src/components/IntelliportCommandsModel.js